<template>
  <div class="rating-avatar">
    <img
      class="rating-avatar__img"
      :src="src || '/lms/img/user-default.jpg'"
      alt=""
    />
    <Icon
      v-if="isLeader"
      class="rating-avatar__img-icon"
      icon="ui-star-volume"
    />
  </div>
</template>

<script>
export default {
  props: {
    src: {},
    isLeader: {
      type: Boolean,
      default: false
    },
    loading: {}
  }
};
</script>
